import api from '@anm/api';
import { UploadMediaFile } from '@anm/api/modules/uploads';
import isMP4 from '@anm/helpers/is/isMP4';
import { useEffect } from 'react';

export type CheckerProps = {
  onStable: (upload: UploadMediaFile) => void;
  onUploadStart?(): void;
  onUploadError?(): void;
  uploadId?: string;
  requireMP4?: boolean;
};

const DELAY = 1000;

let timer: number;

const useUploadChecker = ({ onStable, onUploadStart, onUploadError, uploadId, requireMP4 = false }: CheckerProps) => {
  useEffect(() => {
    if (!uploadId) return;

    const checkUploadStatus = async () => {
      try {
        const uploadEntity = await api().uploads.getUploadMedia({ id: uploadId, isCached: false });

        const isUploadStable = uploadEntity.upload.status === 'stable';
        const hasMP4 = uploadEntity.files.some(f => isMP4(f));

        const isReady = requireMP4 ? isUploadStable && hasMP4 : isUploadStable;

        if (isReady) {
          onStable(uploadEntity);
        } else {
          if (onUploadStart) onUploadStart();

          timer = window.setTimeout(checkUploadStatus, DELAY);
        }
      } catch {
        onUploadError && onUploadError();
      }
    };

    checkUploadStatus();

    return () => clearTimeout(timer);
  }, [uploadId]);
};

export default useUploadChecker;
